import React from 'react'
import { Link } from 'gatsby'
import { PrismicLink, PrismicRichText } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'
import EmblaCarousel from './embla/emblaCarousel'

import Logo from './svg/logoIcon'
import Social from './social'

const PageHeader = ({ pageData, product, type, uid }) => {
  let featuredCards
  if (pageData.featured_cards?.length > 1) {
    featuredCards = pageData.featured_cards
  }

  return (
    <div className={`${uid} page_header relative`}>
      <div className='relative grid grid-cols-1 overflow-hidden grid-rows-1 text-white border-b-4 bg-brand-blue border-brand-orange min-h-screen-1/2'>
        <div className='absolute grid grid-cols-6 md:grid-cols-12 grid-rows-3 divide-x divide-white/20 inset-0 bottom-0'>
          <div className='row-start-1 row-span-3'></div>
          <div className='row-start-2 row-span-2'></div>
          <div className='row-start-1 row-span-3'></div>
          <div className='row-start-2 row-span-2'></div>
          <div className='row-start-1 row-span-3'></div>
          <div className='row-start-2 row-span-2'></div>
          <div className='row-start-1 row-span-3 tw-hidden md:block'></div>
          <div className='row-start-2 row-span-2 tw-hidden md:block'></div>
          <div className='row-start-1 row-span-3 tw-hidden md:block'></div>
          <div className='row-start-2 row-span-2 tw-hidden md:block'></div>
          <div className='row-start-1 row-span-3 tw-hidden md:block'></div>
          <div className='row-start-2 row-span-2 tw-hidden md:block'></div>
        </div>
        {pageData.carousel.length > 0 && (
          <section className='max-w-screen-xl mx-auto w-full relative z-0 flex mt-20 pt-6 justify-center'>
            {pageData.carousel.length > 1 ? (
              <EmblaCarousel dots={false} autoplay={true} arrowPosition='left'>
                {pageData.carousel.map((item, index) => {
                  return (
                    <div key={`carousel-${index}`} className='grid lg:grid-cols-2 lg:gap-10 min-w-full'>
                      <div className='content h-full justify-center' key={`item-${index}`}>
                        {item.pre_title && <p className='pre-title'>{item.pre_title}</p>}
                        <h1 className='mb-0'>{item.title}</h1>
                        {item.text && <p className='prose prose-invert prose-lg'>{item.text}</p>}
                        {item.button_link && (
                          <Link className='button' to={`${item.button_link.url}?product=${product}`}>
                            {item.button_text || 'read more'}
                          </Link>
                        )}
                      </div>
                      <div className='mt-auto relative flex flex-col aspect-square justify-items-end m-4 lg:mt-10'>
                        <Logo className='absolute inset-0 opacity-20' />
                        {item.image.gatsbyImageData && <GatsbyImage className='bg-contain absolute inset-0' image={item.image.gatsbyImageData} alt={item.image.alt || ''} />}
                      </div>
                    </div>
                  )
                })}
              </EmblaCarousel>
            ) : (
              <div className={`${pageData.carousel[0].image.gatsbyImageData ? 'grid lg:grid-cols-2 with-image' : 'text-only pb-14'}`}>
                <div className='content h-full justify-center'>
                  {type === 'product' && (
                    <>
                      {pageData.status ? (
                        <span className='inline-flex items-center rounded-md bg-pink-100 px-2.5 py-0.5 text-base font-medium text-pink-800'>Sold</span>
                      ) : (
                        <span className='inline-flex items-center rounded-md bg-green-100 px-2.5 py-0.5 text-base font-medium text-green-800'>Available</span>
                      )}
                    </>
                  )}
                  {pageData.carousel[0]?.pre_title && <p className='pre-title'>{pageData.carousel[0].pre_title}</p>}
                  <h1 className='mb-0'>{pageData.carousel[0].title}</h1>
                  {pageData.carousel[0]?.text && <p className='prose prose-invert prose-lg'>{pageData.carousel[0].text}</p>}
                  {pageData.carousel[0]?.button_text && (
                    <Link className='button' to={`${pageData.carousel[0].button_link.url}?product=${product}`}>
                      {pageData.carousel[0].button_text}
                    </Link>
                  )}
                </div>
                {pageData.carousel[0].image.gatsbyImageData ? (
                  <div className='relative flex flex-col aspect-square justify-items-end lg:mt-10'>
                    <Logo className='absolute inset-0 opacity-20' />
                    <GatsbyImage className='bg-contain absolute inset-0' image={pageData.carousel[0].image.gatsbyImageData} alt={pageData.carousel[0].image.alt || ''} />
                  </div>
                ) : (
                  <div className='h-full w-full absolute inset-0 max-w-screen-sm mx-auto flex items-center'>
                    <Logo className='opacity-20 min-h-60' />
                  </div>
                )}
              </div>
            )}
          </section>
        )}
        <Social className='text-white absolute right-0 bottom-0 flex md:flex-col m-3 gap-3 md:order-2' />
      </div>
      {featuredCards && (
        <div className='relative z-10 mx-auto w-full max-w-screen-xl'>
          <ul className='group grid gap-6 p-6 md:grid-cols-2'>
            {featuredCards.map((card, index) => {
              return (
                <li key={`card-${index}`} className={`featuredCard-${index} relative flex flex-col p-6 text-center text-white`}>
                  <div className='m-6 flex flex-grow flex-col gap-3'>
                    <div className='prose prose-invert prose-2xl max-w-none pb-3'>
                      <PrismicRichText field={card.title.richText} />
                      <PrismicRichText field={card.text.richText} />
                    </div>
                    <div className='mt-auto text-center text-base'>
                      <PrismicLink className='button button-info text-xl' field={card.button_link}>
                        {card.button_text ? card.button_text : 'Read more'}
                        <span className='absolute inset-0 cursor-pointer' aria-hidden='true'></span>
                      </PrismicLink>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default PageHeader
